import styles from './Card.module.css';
import { motion } from 'framer-motion';

const Card = (props) => {
	const { title, subtitle } = props;

	return (
		<motion.div
			className={styles.card}
			initial={{ opacity: 0, scale: 0.5 }}
			animate={{ opacity: 1, scale: 1 }}
			transition={{ duration: 0.5 }}
		>
			<div className={styles['card-content']}>
				<div className={styles['card-title']}>{title}</div>
				<div className={styles['card-subtitle']}>{subtitle}</div>
			</div>
		</motion.div>
	);
};

export default Card;
